import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  Renderer2,
  effect,
} from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { TranslationService } from '../../services/translation.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClubService } from '../../services/club.service';

declare global {
  interface Window {
    __weatherwidget_init: () => void;
  }
}

@Component({
  selector: 'app-weather-widget',
  imports: [MatTabsModule],
  templateUrl: './weather-widget.component.html',
  styleUrl: './weather-widget.component.scss',
})
export class WeatherWidgetComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  protected weather_location: string | undefined;
  protected main_location: string | undefined;

  readonly WEATHER_BASE_EN = 'https://forecast7.com/en/';
  readonly WEATHER_BASE_GR = 'https://forecast7.com/el/';

  weatherHrefEn = ''; //35d3325d20/karteros/';
  weatherHrefGr = ''; //35d3325d20/karteros/';

  widget!: HTMLElement | null;

  constructor(
    private renderer: Renderer2,
    private translateService: TranslationService,
    private clubsService: ClubService
  ) {
    effect(() => {
      const theme = this.clubsService.theme();

      if (!theme?.locations?.weather_location) return;

      this.weather_location = theme.locations.weather_location;
      this.main_location = theme.locations.main_location;

      this.weatherHrefEn = `${this.WEATHER_BASE_EN}${this.weather_location}`;
      this.weatherHrefGr = `${this.WEATHER_BASE_GR}${this.weather_location}`;

      this.loadWeatherWidgetScript();
    });
  }

  // loading weatherwidget.io script
  private loadWeatherWidgetScript() {
    const scriptId = 'weatherwidget-io-js';
    if (!document.getElementById(scriptId)) {
      const script = this.renderer.createElement('script');
      script.id = scriptId;
      script.src = 'https://weatherwidget.io/js/widget.min.js';
      script.async = true;
      script.onload = () => {
        this.initWeatherWidget();
      };
      this.renderer.appendChild(document.body, script);
    } else {
      this.initWeatherWidget();
    }
  }

  ngOnInit() {
    const widgetGr = document.getElementById('weatherGr');
    const widgetEn = document.getElementById('weatherEn');
    this.translateService.currentLanguage$
      .pipe(takeUntil(this.destroy$))
      .subscribe((lang) => {
        if (widgetGr && widgetEn) {
          if (lang === 'gr') {
            widgetGr.style.display = 'block';
            widgetEn.style.display = 'none';
          } else {
            widgetGr.style.display = 'none';
            widgetEn.style.display = 'block';
          }
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private initWeatherWidget() {
    setTimeout(() => {
      window.__weatherwidget_init();
    }, 0);
  }
}
